
let currentProduct;
let iframeSrc;
let iframeElement;
let customer = 'ADVANTAGELIFTSCOM';

const waitForMazingFunction = new Promise((resolve) => {
    const interval = 50;
    const checkInterval = setInterval(() => {
        if (typeof mazing === 'function') {
            clearInterval(checkInterval);
            resolve();
        }
    }, interval);
});

const waitForElement = (selector, timeout = 55000) => {
    return new Promise((resolve) => {
        const interval = 50;
        let elapsedTime = 0;

        const checkInterval = setInterval(() => {
            const element = document.querySelector(selector);
            if (element) {
                clearInterval(checkInterval);
                resolve(element);
            } else if ((elapsedTime += interval) >= timeout) {
                clearInterval(checkInterval);
                resolve();
            }
        }, interval);
    });
};

// This method gets the sku from the url. This part of the url is used to look for a matching product
// in the mazing world. The project name in the mazing world has to be identical with what this method returns
const getCurrentSKU = () => {
    const url = window.location.href;
    const parts = url.split("/");
    const product = parts.filter(part => part.trim() !== '').pop();
    const productParts = product.split('?');
    currentProduct = `${productParts[0]}`;
    console.log('Final SKU:', currentProduct.toLowerCase());
    return currentProduct.toLowerCase();
};

const cloneAndInsertThumb = (thumbGallery, newImgSrc) => {
    const firstThumb = thumbGallery.children[0];
    if (!firstThumb) return;

    // This clones and inserts the 1. thumb

    const clonedThumb = firstThumb.cloneNode(true);
    clonedThumb.id = 'mazing-thumb';
    clonedThumb.querySelector('button').removeAttribute('aria-current');
    clonedThumb.removeAttribute('data-target');

    const originalImg = clonedThumb.querySelector('img');
    if (!originalImg) return;

    originalImg.style.opacity = '0.4';
    originalImg.style.filter = 'brightness(120%) grayscale(100%)';
    originalImg.style.zIndex = '1';
    originalImg.style.position = 'relative';

    clonedThumb.style.position = 'relative';

    const overlayWrapper = document.createElement('div');
    overlayWrapper.style.position = 'absolute';
    overlayWrapper.style.top = '0';
    overlayWrapper.style.left = '0';
    overlayWrapper.style.width = '100%';
    overlayWrapper.style.height = '100%';
    overlayWrapper.style.boxSizing = 'border-box';
    overlayWrapper.style.zIndex = '2';
    overlayWrapper.style.pointerEvents = 'none';

    const overlayImg = document.createElement('img');
    overlayImg.src = newImgSrc;
    overlayImg.id = 'mazing-img';
    overlayImg.style.width = '100%';
    overlayImg.style.height = '100%';
    overlayImg.style.padding = '20%';
    overlayImg.style.objectFit = 'contain';
    overlayImg.style.filter = 'brightness(0) saturate(100%) invert(27%) sepia(12%) saturate(21%) hue-rotate(5deg) brightness(89%) contrast(84%)';

    overlayWrapper.appendChild(overlayImg);
    clonedThumb.appendChild(overlayWrapper);
    if (thumbGallery.children.length > 1) {
        thumbGallery.insertBefore(clonedThumb, thumbGallery.children[1]);
    } else {
        thumbGallery.appendChild(clonedThumb);
    }
};

const insertIframe = (imgGallery, iframeSrc) => {
    const firstItem = imgGallery.children[0];
    if (!firstItem) return;

    const clonedItem = firstItem.cloneNode(true);
    clonedItem.id = 'mazing-iframe-li';
    clonedItem.classList.remove('is-active');

    const innerDiv = clonedItem.querySelector('div');
    if (!innerDiv) return;

    const originalHeight = firstItem.getBoundingClientRect().height;

    const iframeElement = document.createElement('iframe');
    iframeElement.src = iframeSrc;
    iframeElement.style.width = '100%';
    iframeElement.style.setProperty('height', '100%', 'important');
    iframeElement.style.border = 'none';
    iframeElement.allow = "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; camera *; xr-spatial-tracking;";

    innerDiv.innerHTML = '';
    innerDiv.appendChild(iframeElement);

    innerDiv.style.pointerEvents = 'none';
    iframeElement.style.pointerEvents = 'auto';

    clonedItem.style.height = `${originalHeight}px`;

    if (imgGallery.children.length > 1) {
        imgGallery.insertBefore(clonedItem, imgGallery.children[1]);
    } else {
        imgGallery.appendChild(clonedItem);
    }
};


const setupThumbClickListeners = (thumbGallery, imgGallery) => {
    const thumbs = thumbGallery.children;
    const iframeLi = document.getElementById('mazing-iframe-li');

    // Apply Listener on each thumb
    for (let thumb of thumbs) {
        thumb.addEventListener('click', (e) => {
            e.preventDefault();
            const isMazingThumb = thumb.id === 'mazing-thumb';

            if (isMazingThumb) {
                console.log('Mazing Thumb clicked')
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();

                for (let thumb of thumbs) {
                    thumb.querySelector('button').removeAttribute('aria-current');
                }
                thumb.querySelector('button').setAttribute('aria-current', 'true');

                for (let item of imgGallery.children) {
                    item.classList.remove('is-active');
                }

                if (iframeLi) {
                    iframeLi.classList.add('is-active');
                }

                if (window.innerWidth < 750 && iframeLi && imgGallery) {
                    const offset = iframeLi.offsetLeft;
                    imgGallery.scrollTo({
                        left: offset,
                        behavior: 'smooth'
                    });

                }

            } else {
                const mazingButton = document.getElementById('mazing-thumb')?.querySelector('button');
                if (mazingButton) {
                    mazingButton.removeAttribute('aria-current');
                }

                if (iframeLi) {
                    iframeLi.classList.remove('is-active');
                }
            }
        });
    }
};

const initializeMazing = async () => {
    // GALLERY INTEGRATION

    // Wait for gallery elements
    const imgGallery = await waitForElement('.product__media-list');
    const thumbGallery = await waitForElement('.thumbnail-list');

    const myImageSrc = 'https://cdn.mazing.link/assets/svg/3D.svg';

    // this method returns the iframe src that we use in the iframe that we will later create
    iframeSrc = await mazingProjectAvailable({
        customerName: customer,
        getSKU: getCurrentSKU,
    });
    if (!iframeSrc) {
        console.log('iframeSrc not found, aborting script execution.');
        return;
    }

    // This creates the iframe and inserts it in the imgGallery at the 2. position
    insertIframe(imgGallery, iframeSrc);
    // This clones the first thumb and inserts it in the thumbGallery at the 2. position
    // We clone it so we still have the same thumb background to make the thumb look better
    cloneAndInsertThumb(thumbGallery, myImageSrc);
    // This sets up the click listeners we apply on the thumbs
    setupThumbClickListeners(thumbGallery, imgGallery);
    console.log('Mazing initialized with clean DOM.');

};


const initializeMazingButton = async () => {

    // This method creates the mazing buttons and places them into the given selector
    await mazing({
        customerName: customer,
        buttonConfiguration: {
            customStyle: `
                .mazing-button-container {
                    width: 100%;
                    position: absolute;
                    bottom: 0px;
                    left: 50%;
                    transform: translateX(-50%);
                    justify-content: start;
                    display: flex;
                    justify-content: center;
                    z-index: -1;
                }
                
                .mazing-ar-btn-icon,
                .mazing-threed-btn-icon {
                    filter: brightness(0) saturate(100%) invert(100%);
                    width: fit-content !important;
                    margin: 0 !important;
                }
                
                .mazing-threed-btn,
                .mazing-ar-btn { 
                    box-shadow: none !important;
                    display: flex;
                    justify-content: space-around; 
                    gap: 18px;
                    padding-left: 28px;
                    padding-right: 28px;
                    position: relative;
                    overflow: hidden;
                    z-index: 1;
                    margin-right: 0px !important;
                    background: #E01217 !important;
                    border-radius: 0;
                }
                
                .mazing-threed-btn-text,
                .mazing-ar-btn-text{
                    font-weight: 500;
                    color: white;
                }
            `,
            placementSelector: (() => {
                return '.slider-mobile-gutter'; // This is the container we place the button in
            })(),
            threedBtn: {
                enabled: true,
                icon: true,
                customText: (() => {
                    const lang = navigator.language || navigator.userLanguage;
                    const translations = {
                        "en": "View in 3D",
                        "de": "In 3D ansehen",
                        "fr": "Voir en 3D",
                        "es": "Ver en 3D"
                    };

                    return translations[lang.split("-")[0]] || translations["en"];
                })()
            },
            arBtn: {
                enabled: false,
                icon: true,
                customText: (() => {
                    const lang = navigator.language || navigator.userLanguage;
                    const translations = {
                        "en": "View in Room",
                        "de": "Im Raum anzeigen",
                        "fr": "Voir dans votre espace",
                        "es": "Ver en tu espacio"
                    };

                    return translations[lang.split("-")[0]] || translations["en"];
                })()
            }
        },
        getSKU: getCurrentSKU
    });

    console.log('Mazing initialized.');

}

const initializeScript = async () => {
    try {
        // Wait for mazing function to be available
        await waitForMazingFunction;
        console.log('mazingProjectAvailable is now available');

        // On desktop, we initialize the gallery integration and on mobile, we initialize the
        // mazing button solution. It's a better UI choice
        if (window.innerWidth > 768) {
            // Gallery integration
            await initializeMazing();
        } else {
            // Mobile button integration
            await initializeMazingButton();
            setTimeout(() => {
                const container = document.querySelector('.mazing-button-container');
                if (container) {
                    container.style.zIndex = '1';
                    console.log('Updated z-index of .mazing-button-container to 1');
                }
            }, 1000);
        }
        console.log('Initialized successfully.');
    } catch (error) {
        console.error('Initialization failed:', error);
    }
};
initializeScript();
